export default {
      id: "Icon--newTab-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--newTab",
      toString: function () {
        return this.url;
      }
    }